import { AgFinancingDocumentType, PledgeLevel } from '@indigo-ag/schema';
import { SelectOption } from '@indigo-ag/component-module';
import i18next from 'core/i18n';

import { text as textUtils } from '../utils/text.util';

export const phase3FileTypes: AgFinancingDocumentType[] = [
  AgFinancingDocumentType.REGISTERED_MINUTA,
  AgFinancingDocumentType.REGISTERED_LETTER_OF_CONSENT,
  AgFinancingDocumentType.CERTIFICATE_OF_PLEDGE,
  AgFinancingDocumentType.OTHER_VALIDATION,
  AgFinancingDocumentType.AMENDMENT_SIGN,
  AgFinancingDocumentType.PROMISSORY_NOTE_SIGNED,
  AgFinancingDocumentType.SIGNED_CPR,
  AgFinancingDocumentType.AF_POST_REGISTRATION_CERTIFICATE,
  AgFinancingDocumentType.NOTARIZED_CPR,
  AgFinancingDocumentType.NOTARIZED_CPR_B3
];

export const pledgeLevelTranslations: { [key in PledgeLevel]: string } & { [key: string]: string } = {
  [PledgeLevel.FIRST]: i18next.t('pledgeLevelFirst'),
  [PledgeLevel.SECOND]: i18next.t('pledgeLevelSecond'),
  [PledgeLevel.THIRD]: i18next.t('pledgeLevelThird'),
  [PledgeLevel.NEGATIVE]: i18next.t('pledgeLevelNegative')
};

export const pledgeLevelOptions: SelectOption<PledgeLevel>[] = Object.keys(PledgeLevel).map(pledgeLevel => ({
  name: textUtils.toTitleCase(pledgeLevelTranslations[pledgeLevel]),
  value: pledgeLevel as PledgeLevel
}));
